import { Mail, Phone } from "lucide-react";
import { BRAND } from "@/lib/constants";

export default function Footer() {
    const year = new Date().getFullYear();

    const links = [
        { label: "Problema", id: "problema" },
        { label: "Solución", id: "solucion" },
        { label: "Autoridad", id: "autoridad" },
        { label: "Beneficios", id: "beneficios" },
        { label: "Curso gratis", id: "curso" },
        { label: "Contacto", id: "contacto" },
    ];

    return (
        <footer
            data-testid="footer"
            className="relative bg-[#F7F3EE] border-t border-[#1E1E1E]/10"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-6 md:py-7">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5">
                    {/* Brand */}
                    <div className="flex items-center gap-3 shrink-0">
                        <img
                            src={BRAND.logo}
                            alt="Hewser Personal Branding"
                            className="h-9 w-9 object-contain"
                        />
                        <div className="leading-tight">
                            <div className="font-display text-[14px] text-[#1E1E1E]">
                                Hewser ®
                            </div>
                            <div className="font-italic-display text-[11px] text-[#8C7C72]">
                                Personal Branding
                            </div>
                        </div>
                    </div>

                    {/* Horizontal nav */}
                    <nav className="flex flex-wrap items-center gap-x-5 gap-y-2 lg:gap-x-6">
                        {links.map((l) => (
                            <a
                                key={l.id}
                                href={`#${l.id}`}
                                data-testid={`footer-link-${l.id}`}
                                className="text-[11px] tracking-[0.2em] uppercase text-[#1E1E1E]/70 hover:text-[#C6A76A] transition-colors"
                            >
                                {l.label}
                            </a>
                        ))}
                    </nav>

                    {/* Contact compact */}
                    <div className="flex flex-wrap items-center gap-4 md:gap-6 shrink-0">
                        <a
                            href={`https://wa.me/${BRAND.whatsappRaw}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-whatsapp"
                            className="inline-flex items-center gap-2 text-[12px] text-[#1E1E1E] hover:text-[#C6A76A] transition-colors"
                        >
                            <Phone size={14} strokeWidth={1.5} />
                            <span>{BRAND.whatsappDisplay}</span>
                        </a>
                        <a
                            href={`mailto:${BRAND.email}`}
                            data-testid="footer-email"
                            className="inline-flex items-center gap-2 text-[12px] text-[#1E1E1E] hover:text-[#C6A76A] transition-colors"
                        >
                            <Mail size={14} strokeWidth={1.5} />
                            <span className="break-all">{BRAND.email}</span>
                        </a>
                    </div>
                </div>

                <div className="mt-5 pt-4 border-t border-[#1E1E1E]/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
                    <p className="text-[10px] tracking-[0.18em] uppercase text-[#1E1E1E]/55">
                        © {year} Hewser Personal Branding. Todos los derechos reservados.
                    </p>
                    <p className="font-italic-display text-[12px] text-[#8C7C72]">
                        Imagen con propósito.
                    </p>
                </div>
            </div>
        </footer>
    );
}
